import { render, staticRenderFns } from "./CustomerTrainingItemQuizAnswer.vue?vue&type=template&id=642dd4ca&"
import script from "./CustomerTrainingItemQuizAnswer.vue?vue&type=script&lang=js&"
export * from "./CustomerTrainingItemQuizAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports